<template>
  <div>
    <!-- Title -->
    <div class="d-flex justify-space-between mb-2">
      <div class="page-title">ระบบประเมินระดับเทคโนโลยี TCCL</div>
    </div>
    <div class="d-flex align-center page-title">
      <div class="icon-gradient mr-3"></div>
      <div class="page-sub-title">รายละเอียดโครงการ</div>
    </div>

    <!-- Status Step -->
    <StatusStep
      v-if="!$route.query.preview"
      :current-step="currentStep"
      :steps="documentSteps"
      @onClick="jumpStep"
    />

    <!-- Form -->
<v-form ref="form1" v-model="valid" lazy-validation>
  <Tccl1   v-if="currentStep === 1" :formData="formData" :isLoading="isLoading" />
    <Button @onClick="nextForm" theme="1" :disabled="isLoading || doNotSubmit">ต่อไปc</Button>
</v-form>
<!-- 
<form ref="form2" @submit.prevent="nextFormStep2" v-if="currentStep === 2">
  <Tccl2 :formData="formData" />
  <div class="d-flex justify-space-between mt-4">
    <Button theme="3" @click="backForm">&lt; ย้อนกลับ</Button>
    <Button type="submit" theme="1" :disabled="isLoading || doNotSubmit">ต่อไป</Button>
  </div>
</form>

<form ref="form3" @submit.prevent="submitFinal" v-if="currentStep === 3">
  <Tccl3 :formData="formData" />
  <div class="d-flex justify-space-between mt-4">
    <Button theme="3" @click="backForm">&lt; ย้อนกลับ</Button>
    <Button type="submit" theme="1" :disabled="isLoading || doNotSubmit">บันทึก</Button>
  </div>
</form> -->


  
  </div>
</template>

<script>
import StatusStep from "@/components/StatusStep.vue";
import Button from "@/components/input/Button.vue";
import Tccl1 from "./Form/Tccl1.vue";
import Tccl2 from "./Form/Tccl2.vue";
import Tccl3 from "./Form/Tccl3.vue";
import { mapState } from "vuex";

export default {
  name: "TechnologyEvaluationCreate",
  components: { StatusStep, Button, Tccl1, Tccl2, Tccl3 },
  data() {
    return {
      currentStep: 1,
      doNotSubmit: false,
      updateId: undefined,
      documentSteps: [
        { no: 1, name: "รายละเอียด" },
        { no: 2, name: "ไฟล์แนบ" },
        { no: 3, name: "การประเมิน" }
      ],
      formData: {
        industry_category: '',
        industry_group: '',
        fiscal_year: '',
        project_code: '',
        project_name: '',
        researcher: '',
        researcher_email: '',
        attachment: [],
        evaluation: [],
      },
      valid: true
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
      userInfo: (state) => state.Auth.User,
    }),
  },
  methods: {
    submitForm() {
      console.log(this.formData);
      const form = this.$refs.mainForm;
      if (form && !form.checkValidity()) {
        form.reportValidity();
        return;
      }
      this.nextForm();
    },
    async nextForm() {
      console.log(this.formData);
      console.log(this.$refs.form1.validate());
       if (this.$refs.form1.validate()) {
        this.$emit('stepChange', this.form)
      }
      // const error = await this.saveDraft();
      // if (error) return;

      // if (this.currentStep < this.documentSteps.length) {
      //   this.currentStep += 1;
      // } else {
      //   this.$router.push({ name: "TechnologyEvaluation" });
      // }
      // this.$vuetify.goTo("#app");
    },
    async saveDraft() {
      const payload = { ...this.formData };
      let res;

      if (this.$route.query.id || this.updateId) {
        payload.id = this.$route.query.id || this.updateId;
        res = await this.$apiFire("TechnologyEvaluation/updateTccl", payload);
        if (!res || !res.id) {
          this.$store.commit("General/setModal", {
            title: "Error",
            text: "ไม่สามารถบันทึกข้อมูลได้",
            theme: "error",
          });
          return true;
        }
      } else {
        res = await this.$apiFire("TechnologyEvaluation/storeTccl", payload);
        if (res) {
          this.updateId = res;
          window.history.replaceState({}, null, window.location.href + "&id=" + res);
        } else {
          this.$store.commit("General/setModal", {
            title: "Error",
            text: "ไม่สามารถสร้างข้อมูลได้",
            theme: "error",
          });
          return true;
        }
      }
    },
    backForm() {
      if (this.currentStep > 1) {
        this.saveDraft();
        this.currentStep -= 1;
        this.$vuetify.goTo("#app");
      }
    },
    jumpStep(step) {
      if (step === this.currentStep) return;
      if (this.isLoading) return;
      this.currentStep = step;
      this.$vuetify.goTo("#app");
    },
    routeIndex() {
      this.$router.push({ name: "TechnologyEvaluation" });
    },
  },
};
</script>

<style scoped>
.icon-gradient {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #F15A29, #F7941D);
  -webkit-mask: url('https://api.iconify.design/fluent:mail-template-48-filled.svg?color=white') no-repeat center;
  mask: url('https://api.iconify.design/fluent:mail-template-48-filled.svg?color=white') no-repeat center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
</style>